var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBustedText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 715.7 145.7",
    style: {
      enableBackground: "new 0 0 715.7 145.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,127.9V17.8C0,8.1,5.5,2.4,14.7,2.4h46.6c26.5,0,43.1,13.6,43.1,35.2c0,15.4-11.5,28.3-26.5,30.6v0.8 c19.1,1.5,33.2,15.4,33.2,34.1c0,24.8-18.7,40.3-48.7,40.3H14.7C5.5,143.4,0,137.7,0,127.9z M50.7,61c15.7,0,24.7-6.9,24.7-18.8 c0-11.3-7.9-17.8-21.7-17.8H29.5V61H50.7z M54.9,121.4c17,0,26.2-7.2,26.2-20.7c0-13.2-9.5-20.2-26.9-20.2H29.5v40.9H54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.7,93.6V15.9c0-9.8,5.5-15.4,14.7-15.4s14.7,5.7,14.7,15.4v74.7c0,18.1,10.6,29.9,29.6,29.9 c18.8,0,29.5-11.8,29.5-29.9V15.9c0-9.8,5.5-15.4,14.7-15.4s14.7,5.7,14.7,15.4v77.6c0,31.1-22.9,52.1-59,52.1 C143.7,145.7,120.7,124.6,120.7,93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.2,118.7c-1-2.5-1.6-5.3-1.6-7.9c0-7.8,5.4-13,13-13c6.1,0,10.1,2.3,13.6,8.6 c4.6,10.7,15.6,15.6,29.1,15.6c15.8,0,26.6-7.6,26.6-18c0-9.3-6.6-14.6-24.3-18.2l-14.9-2.9c-28.1-5.6-41.9-19-41.9-40 c0-25.8,22.5-42.9,53.8-42.9c25.8,0,45.2,10.8,51.5,29.2c0.7,2,1.1,4,1.1,6.5c0,7-5.1,11.8-12.6,11.8c-6.6,0-10.7-2.6-14.1-8.7 c-4.7-10.6-13.8-15-25.9-15c-14.6,0-24.2,6.8-24.2,17.2c0,8.7,6.7,14.1,23.4,17.4l14.8,3c29.9,6,42.8,18,42.8,39.4 c0,27.5-21.6,44.9-56.7,44.9C277.5,145.7,258.8,134.1,253.2,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M407.8,129.9v-103h-29.1c-8,0-13.4-4.6-13.4-12.2s5.3-12.2,13.4-12.2h87.8c8,0,13.3,4.6,13.3,12.2 s-5.4,12.2-13.3,12.2h-29.2v103c0,9.7-5.5,15.3-14.7,15.3S407.8,139.6,407.8,129.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.2,127.9V17.8c0-9.7,5.5-15.3,14.7-15.3h67c8.1,0,13.4,4.6,13.4,12.2S577,26.9,569,26.9h-52.2v33.9h49.7 c7.3,0,12.3,4.3,12.3,11.3s-4.9,11.3-12.3,11.3h-49.7v35.5H569c8,0,13.4,4.6,13.4,12.2s-5.3,12.2-13.4,12.2h-67 C492.7,143.4,487.2,137.7,487.2,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M594.7,127.9V17.8c0-9.7,5.5-15.3,14.7-15.3h39.1c42.3,0,67.2,25.2,67.2,69.9s-24.9,71-67.2,71h-39.1 C600.1,143.4,594.7,137.7,594.7,127.9z M645,118.9c26.4,0,40.6-16,40.6-46.5c0-29.5-14.6-45.7-40.6-45.7h-20.8v92.2H645z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBustedText);
export default __webpack_public_path__ + "static/media/busted_text.7527268c6033e6d6ae4b5482910bae7c.svg";
export { ForwardRef as ReactComponent };